import versionData from './version.json';

export interface AppVersion {
  /** semver iz package.json (npr. "0.4.0") */
  version: string;
  /** kratek git commit hash */
  sha: string;
  /** git veja ob buildu */
  branch: string;
  /** 'prod' (app.sersen.eu) ali 'dev' (dev.sersen.eu) */
  env: 'prod' | 'dev' | string;
  /** ISO čas builda */
  builtAt: string;
}

export const APP_VERSION = versionData as AppVersion;

export const isProdBuild = APP_VERSION.env === 'prod';

/** Kratka značka: PROD = "v0.4.0", DEV = "dev · feat/x · abc1234" */
export const versionLabel = isProdBuild
  ? `v${APP_VERSION.version}`
  : `dev · ${APP_VERSION.branch} · ${APP_VERSION.sha}`;
